<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <ModalComponent
            name="add-fields"
            title="Añadir nuevo campo"
            @close="() => close(false)"
        >
            <b-row>
                <b-col cols="12">
                    <template v-if="fieldsToSelect.length > 0">
                        <label for="fields-select">Seleccione los campos que quiere añadir</label>
                        <ValidationProvider name="fields-select-validation" rules="required" v-slot="{ errors }">
                            <multiselect
                                id="fields-select"
                                name="fields-select"
                                v-model="fieldsSelect"
                                :options="fieldsToSelect"
                                placeholder="Seleccione el campo"
                                class="mb-3"
                                track-by="id"
                                label="name"
                                style="z-index: 999;"
                                data-cy="selector-campos"
                                :max-height="130"
                                :multiple="true"
                            />
                            <span v-if="errors[0]" class="alert alert-danger" style="display: block">Debe seleccionar algún campo para continuar</span>
                        </ValidationProvider>
                        <div class="checkbox-container" v-if="hasDeportistasInRoute">
                            <input
                                type="checkbox"
                                id="deportista-check"
                                data-cy="deportista"
                                v-model="checks.deportista"
                            />
                            <label class="form-check-label" for="deportista-check">Deportista</label>
                            <input
                                type="checkbox"
                                id="representante1-check"
                                data-cy="responsables"
                                v-model="checks.representantes"
                            />
                            <label class="form-check-label" for="representante1-check">Responsables</label>
                            <span v-if="errorChecks" class="alert alert-danger" style="display: block">Debe seleccionar al menos un checkbox para continuar</span>
                        </div>
                    </template>
                    <div v-else class="alert alert-danger">
                        No hay campos disponibles para seleccionar
                    </div>
                </b-col>
                <b-col cols="12">
                    <button type="submit" class="btn btn-primary" id="add-field" data-cy="add-fields" :disabled="fieldsSelect.length == 0">Continuar</button>
                </b-col>
            </b-row>
        </ModalComponent>
    </ValidationObserver>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";

    export default {
        props: ['filters'],
        data() {
            return {
                fieldsSelect: [],
                fieldsToSelect: [],
                checks: {
                    deportista: false,
                    representantes: false,
                },
                errorChecks: false
            }
        },
        methods: {
            getFieldsToSelect() {
                const params = {
                    filters : this.filters,
                    teatro_id: this.teatro.id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.teatro.forms.to-select'), params).then(res => {
                    this.fieldsToSelect = res.data.data;
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                });
            },
            emitFieldsIds() {
                var fieldsIds = [];
                fieldsIds = this.fieldsSelect.map(field => field.id);

                this.$emit('vincularFields', fieldsIds);
                this.close(true);
                this.getFieldsToSelect();
            },
            close(creado) {
                this.fieldsSelect = [];
                this.$emit('close', 'add-fields', creado);
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();

                if(this.hasDeportistasInRoute){
                    if (!this.checks.deportista && !this.checks.representantes) {
                        this.errorChecks = true;
                        this.$toast.error('Debe seleccionar al menos un checkbox para continuar.');
                        return;
                    }else {
                        this.errorChecks = false;
                    }

                    if(isValid) {
                        this.emitFieldsIdsDeportistas();
                        return;
                    }
                }

                if(isValid) {
                    this.emitFieldsIds();
                }
            },
            emitFieldsIdsDeportistas() {
                var fieldsIds = [];
                fieldsIds = this.fieldsSelect.map(field => ({
                    id: field.id,
                    deportista: this.checks.deportista ? 1 : 0,
                    representante: this.checks.representantes  ? 1 : 0
                }));

                this.$emit('vincularFields', fieldsIds);
                this.close(true);
                this.getFieldsToSelect();
            }
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            },
            hasDeportistasInRoute() {
                return this.$route.path.includes('deportistas');
            }
        },
        created() {
            this.getFieldsToSelect();
        },
        components: {
            ModalComponent
        }
    }
</script>